import firebase from '../../firebase';

const fetchLearnedMapping = async (data) => {
    const mapping = await firebase.functions().httpsCallable('rides-getLearnedImportMapping')(data);
    return mapping && mapping.data;
};

export default fetchLearnedMapping;
